import Vue from 'vue';
import * as moment from 'moment';

Vue.filter('upper', (value) => value && value.toUpperCase());
Vue.filter('lower', (value) => value && value.toLowerCase());
Vue.filter('capitalize', (value) => value && value.toLowerCase().replace(/(^|\s)\S/g, (l) => l.toUpperCase()));
Vue.filter('formatDate', (value) => moment(value).format('DD/MM/YYYY'));
Vue.filter('formatDateShort', (value) => moment(value).format('DD/MM'));
